import { render, staticRenderFns } from "./Integridade.vue?vue&type=template&id=476c6590&"
import script from "./Integridade.vue?vue&type=script&lang=js&"
export * from "./Integridade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports